/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-extra-boolean-cast */
import React, { useState, useMemo } from 'react';
import { Table, Input, Space, Spin, Dropdown, Button, Alert, Avatar, Tag, Tooltip, Modal, message } from 'antd';
import { SearchOutlined, DownloadOutlined, DownOutlined, EyeOutlined } from '@ant-design/icons';
import { ExportCsv, ExportPdf } from '@material-table/exporters';
import moment from 'moment';
import { EmpDetailsDialog, ImagePreview } from '../../../../../common';
import { themeColor } from '../../../../../../config/theme/themeVariables';
import { TableWrapper } from '../../../../../../container/styled';
import { API_ENDPOINT } from '../../../../../../config/config';

const EmployeesTab = ({ data, loading, error, startDate, endDate }) => {
  const [search, setSearch] = useState('');
  const [exportMenuVisible, setExportMenuVisible] = useState(false);
  const [profilePicture, setProfilePicture] = useState('');
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editID, setEditID] = useState(null);
  const [reload, setReload] = useState(false);

  const handleSearch = (value) => {
    setSearch(value);
  };

  const getFilteredData = () => {
    return data.filter(row => {
      const searchLower = search.toLowerCase();
      return (
        row.name?.toLowerCase().includes(searchLower) ||
        row.contact?.toLowerCase().includes(searchLower) ||
        row.cnic?.toLowerCase().includes(searchLower) ||
        row.comp_name?.toLowerCase().includes(searchLower)
      );
    });
  };

  const handleExportCsv = () => {
    try {
      const filteredData = getFilteredData();
      const headers = [
        { title: 'SrNo' },
        { title: 'Name' },
        { title: 'Contact' },
        { title: 'CNIC' },
        { title: 'Company' },
        { title: 'Reg: Date' },
        { title: 'IsEmployed' },
        { title: 'IsActive' },
      ];
      const csvData = filteredData.map((row, index) => [
        index + 1,
        row.name || '',
        row.contact || '',
        row.cnic || '',
        row.comp_name || '',
        row.created_at ? moment(row.created_at).format('YYYY-MM-DD hh:mm a') : '',
        row.is_employeed ? 'Working' : 'Fired',
        row.is_active ? 'Active' : 'InActive',
      ]);
      const fileName = `employees_data_${startDate}_${endDate}${search ? `_${search}` : ''}`;
      ExportCsv(headers, csvData, fileName);
      setExportMenuVisible(false);
    } catch (exportError) {
      console.error('Error exporting CSV:', exportError);
    }
  };

  const handleExportPdf = () => {
    try {
      const filteredData = getFilteredData();
      const headers = [
        { title: 'SrNo' },
        { title: 'Name' },
        { title: 'Contact' },
        { title: 'CNIC' },
        { title: 'Company' },
        { title: 'Reg: Date' },
        { title: 'IsEmployed' },
        { title: 'IsActive' },
      ];
      const pdfData = filteredData.map((row, index) => [
        index + 1,
        row.name || '',
        row.contact || '',
        row.cnic || '',
        row.comp_name || '',
        row.created_at ? moment(row.created_at).format('YYYY-MM-DD hh:mm a') : '',
        row.is_employeed ? 'Working' : 'Fired',
        row.is_active ? 'Active' : 'InActive',
      ]);
      const fileName = `employees_data_${startDate}_${endDate}${search ? `_${search}` : ''}`;
      ExportPdf(headers, pdfData, fileName);
      setExportMenuVisible(false);
    } catch (exportError) {
      console.error('Error exporting PDF:', exportError);
    }
  };

  const handleViewProfile = (profile_picture) => {
    if (profile_picture) {
      setProfilePicture(profile_picture);
      setIsImageModalOpen(true);
    } else {
      message.info('No profile image');
    }
  };

  const handleViewDetails = (record) => {
    setEditID(record.id);
    setShowForm(true);
  };

  const columns = useMemo(() => [
    {
      title: '',
      dataIndex: 'profile_picture',
      key: 'profile_picture',
      width: 60,
      onCell: () => ({ className: 'w-20 text-center' }),
      render: (profile_picture, record) => {
        return (
          <Avatar
            className='cursor-pointer'
            src={profile_picture ? `${API_ENDPOINT}/${profile_picture}` : require('../../../../../../static/img/avatar/profileImage.png')}
            size={40}
            onClick={() => handleViewProfile(`${API_ENDPOINT}/${profile_picture}`)}
          />
        );
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 200,
      export: true,
    },
    {
      title: 'Contact',
      dataIndex: 'contact',
      key: 'contact',
      width: 150,
      export: true,
      onCell: () => ({ className: 'w-40 text-center' }),
    },
    {
      title: 'CNIC',
      dataIndex: 'cnic',
      key: 'cnic',
      width: 150,
      export: true,
      onCell: () => ({ className: 'w-40 text-center' }),
    },
    {
      title: 'Company',
      dataIndex: 'comp_name',
      key: 'comp_name',
      width: 200,
      export: true,
    },
    {
      title: 'Reg: Date',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 180,
      export: true,
      onCell: () => ({ className: 'w-40 text-center' }),
      render: (text) => text ? moment(text).format('DD/MM/YYYY hh:mm a') : 'N/A',
    },
    {
      title: 'IsEmployed',
      dataIndex: 'is_employeed',
      key: 'is_employeed',
      width: 120,
      export: true,
      onCell: () => ({ className: 'w-10' }),
      render: (is_employeed) => {
        let color = themeColor['danger-color'];
        let lblStr = 'Fired';

        if (Boolean(is_employeed)) {
          lblStr = 'Working';
          color = themeColor['success-color'];
        }

        return (
          <div className="flex justify-content-center">
            <div className='taglist-wrap select-none'>
              <Tag color={color}>{lblStr}</Tag>
            </div>
          </div>
        );
      },
    },
    {
      title: 'IsActive',
      dataIndex: 'is_active',
      key: 'is_active',
      width: 120,
      export: true,
      onCell: () => ({ className: 'w-10' }),
      render: (is_active) => {
        let color = themeColor['danger-color'];
        let lblStr = 'InActive';

        if (Boolean(is_active)) {
          lblStr = 'Active';
          color = themeColor['success-color'];
        }

        return (
          <div className="flex flex-row justify-center select-none">
            <div className='taglist-wrap select-none'>
              <Tag color={color}>{lblStr}</Tag>
            </div>
          </div>
        );
      },
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 100,
      export: false,
      onCell: () => ({ className: 'w-20' }),
      render: (_, record) => {
        return (
          <div className='flex flex-row justify-center select-none'>
            <Tooltip title='Record Details' className='select-none'>
              <Button
                type="text"
                icon={<EyeOutlined className='hover:scale-110 hover:text-blue-400 hover:cursor-pointer transform transition duration-300 ease-in-out' />}
                onClick={() => handleViewDetails(record)}
                size="small"
              />
            </Tooltip>
          </div>
        );
      },
    },
  ], []);

  const filteredData = useMemo(() => getFilteredData(), [data, search]);

  const exportMenuItems = [
    {
      key: 'csv',
      label: 'Export as CSV',
      icon: <DownloadOutlined />,
      onClick: handleExportCsv,
    },
    {
      key: 'pdf',
      label: 'Export as PDF',
      icon: <DownloadOutlined />,
      onClick: handleExportPdf,
    },
  ];

  if (loading) {
    return (
      <div className="text-center py-8">
        <Spin size="large" />
        <p className="mt-4 text-gray-600">Loading employees data...</p>
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        message="Error Loading Employees Data"
        description={error}
        type="error"
        showIcon
        className="text-center"
      />
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <ImagePreview
          visible={isImageModalOpen}
          imageSrc={profilePicture}
          onClose={() => {
            setProfilePicture(null);
            setIsImageModalOpen(false);
          }}
        />

        <h2 className="text-lg font-semibold">Employees List</h2>
        <Space>
          <Input
            placeholder="Search employees..."
            prefix={<SearchOutlined />}
            onChange={(e) => handleSearch(e.target.value)}
            style={{ width: 200 }}
          />
          <Dropdown
            menu={{ items: exportMenuItems }}
            trigger={['click']}
            open={exportMenuVisible}
            onOpenChange={setExportMenuVisible}
          >
            <Button type="primary" icon={<DownOutlined />}>
              Export
            </Button>
          </Dropdown>
        </Space>
      </div>
      <div className="ninjadasj-datatable">
        <TableWrapper >
          <Table
            columns={columns}
            dataSource={filteredData}
            rowKey="id"
            scroll={{ x: 'max-content' }}
            pagination={{ pageSize: 10 }}
            size="middle"
            bordered
          />
        </TableWrapper>
      </div>

      {showForm && <EmpDetailsDialog showDialog={() => { setShowForm(false); setEditID(null) }} setReload={setReload} editId={editID || null} isEdit={editID || false} />}
    </div>
  );
};

export default EmployeesTab; 